import CalenderComponentUpdated from "./CalenderComponent";
import PatientBookingProvider from "./context/PatientBookingProvider";

function PatientBookingV2() {
  return (
    <PatientBookingProvider>
      <CalenderComponentUpdated />
    </PatientBookingProvider>
  );
}

export default PatientBookingV2;
